module.exports = "/_next/static/images/TwilioDeveloperPlan@2x-1d7a8c28565244fa1f11e6c8899b591e.webp";